import { serviceName } from '../resources/serviceConstants';
import { DEAL_DETAIL_VIEW } from '../resources/endPoint';

export const getDealDetailViewDetails = (dealId) => ({
  url: `${DEAL_DETAIL_VIEW}?deal_id=${dealId}`,
  method: 'get',
  headers: { 'content-type': 'application/json'},
  authRequired: false,
  csrfToken: true,
  service: serviceName.DEAL_TRANSITION_MS,
});
